/* Filter-bar helpers — single source for "All / Pending / Approved / …"
   filter chips used across the admin and architect surfaces. Derives
   chip labels from the canonical `/lib/workflows.js` registry so a
   status label never has to be hand-typed in a filter array again.

   Each helper returns `[{ key, label }, …]`. The first entry is always
   an "All" chip with the literal key `"all"`. */

import { getStatusTone } from "./workflows";

/* Short overrides used only in filter bars (where vertical space is
   tight and "Requested" reads cleaner as "New"). The detail-page and
   pill registry remain untouched so the canonical label still wins
   in every other surface. */
const FILTER_SHORT_LABELS = {
  "Consultation Requested": "New",
};

export function getFilterLabel(value) {
  if (value === "all") return "All";
  if (FILTER_SHORT_LABELS[value]) return FILTER_SHORT_LABELS[value];
  const t = getStatusTone(value);
  return t.label || value;
}

/* Build a filter-chip array (with leading "All") from an ordered list
   of backend status keys. */
export function buildFilterBar(keys) {
  return [
    { key: "all", label: "All" },
    ...keys.map((k) => ({ key: k, label: getFilterLabel(k) })),
  ];
}
